import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api-client';

export const userAppAccessKeys = {
  byUserId: (userId: string | null) => ['admin-user-app-access', userId] as const,
};

export function useUserAppAccess(userId: string | null) {
  return useQuery({
    queryKey: userAppAccessKeys.byUserId(userId),
    queryFn: async () =>
      (await api.get<{ app_keys: string[] }>(`/admin/users/${userId}/app-access`)).app_keys,
    enabled: !!userId,
  });
}

export interface SetUserAppAccessInput {
  userId: string;
  appKeys: string[];
}

export function useSetUserAppAccess() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, appKeys }: SetUserAppAccessInput) =>
      api.put<{ app_keys: string[] }>(`/admin/users/${userId}/app-access`, {
        app_keys: appKeys,
      }),
    onSuccess: (_data, { userId }) => {
      qc.invalidateQueries({ queryKey: userAppAccessKeys.byUserId(userId) });
    },
  });
}
